import styled from 'styled-components';
import { DateTimeInput } from 'ui-components/src/components/atoms/DateTimeInput';

export const StyledDateTimeInput = styled(DateTimeInput)`
  margin-top: 16px;
`;
